module.exports = __webpack_public_path__ + "img/inn7.f95284f5.png";